import React from "react";

const FetchingStatus = ({ message = "fetching..." }) => {
  return <p>{message}</p>;
};

export default FetchingStatus;
